import {
  ALL_SERVICE_CODES,
  IServiceCode,
  IServiceProvider,
  SERVICE_PROVIDER_OPTIONS,
  ServiceCode,
  ServiceCodeType,
} from '@principle-theorem/principle-core/interfaces';
import { prefixCharacters } from '@principle-theorem/shared';
import { isString } from 'lodash';

export class ServiceProviderHandler {
  static resolveServiceProviderByType(
    type?: ServiceCodeType
  ): IServiceProvider | undefined {
    return SERVICE_PROVIDER_OPTIONS.find(
      (serviceProvider) => serviceProvider.type === type
    );
  }

  static resolveServiceCode(
    type: ServiceCodeType | undefined,
    serviceCode: ServiceCode
  ): IServiceCode | undefined {
    if (!type) {
      return;
    }

    const serviceProvider = this.resolveServiceProviderByType(type);
    if (!serviceProvider) {
      return;
    }
    const code = getServiceCodeNumberString(serviceCode);
    const foundCode =
      serviceProvider.items[code] ??
      Object.values(serviceProvider.items).find((item) =>
        isSameServiceCode(item.code, serviceCode)
      ) ??
      Object.values(serviceProvider.items).find(
        (item) => String(item.rootCode).toUpperCase() === code.toUpperCase()
      );

    if (!foundCode) {
      return;
    }

    return {
      ...foundCode,
      type,
    };
  }

  static findServiceCode(code: ServiceCode): IServiceCode | undefined {
    return ALL_SERVICE_CODES.find((currentCode) =>
      isSameServiceCode(currentCode.code, code)
    );
  }
}

export function getServiceCodeNumberString(
  serviceCode: number | string
): string {
  if (isString(serviceCode)) {
    return serviceCode.toUpperCase();
  }
  if (serviceCode <= 999) {
    const to3DigitADACode = prefixCharacters('0', 3);
    return to3DigitADACode(serviceCode);
  }
  return serviceCode.toString();
}

export function isSameServiceCode(
  codeA: ServiceCode,
  codeB: ServiceCode
): boolean {
  return (
    getServiceCodeNumberString(codeA) === getServiceCodeNumberString(codeB)
  );
}
